/* eslint-disable react-hooks/exhaustive-deps */
import { PointReviewItem } from 'components/point-review-item';
import { RewardReviewItem } from 'components/reward-review-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Box from 'components/ui/box';
import { useContext, useEffect, useMemo, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import {
  getMissaoGestor,
  getMissaoEquipe,
  getMissaoEquipeFeedback,
  getMissaoGestorPublic,
  getMissaoEquipePublic,
} from 'services/achievement.service';
import { getKPIHistory, getKPIPublicHistoryByTime, getPlayerInfo } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';
import Avatar from 'funifier-nice-avatar';
import { User } from 'types/user';
import { AuthContext, useAuth } from 'context/AuthContext';
import { RedePoint } from './point';
import Humanograma from 'components/Humanograma';
import CustomSelect from 'components/custom-select';
import { getIndexByValue } from 'utils/helpers';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { getLevelTitle } from 'services/utils';
import { useModal } from 'context/ModalContext';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';

interface RedeDetailDetailProps {
  id?: string;
  onClose: () => void;
}
export function RedeDetail({ id, onClose }: RedeDetailDetailProps) {
  const { currentCycle, user } = useAuth();
  const { showModal } = useModal();

  const [currentUser, setCurrentUser] = useState<User>();
  const [userInfo, setUserInfo] = useState<any>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [optionsCycle, setOptionsCycle] = useState<any>([]);
  const [activeItem, setActiveItem] = useState('');
  const { realCycle } = useContext(AuthContext);

  const [list, setList] = useState<unknown[]>();
  const [missionList, setMissionList] = useState<unknown[]>();

  const [loadingList, setLoadingList] = useState(true);
  const [loadingMissionList, setLoadingMissionList] = useState(true);

  const activeCycleObj = useMemo(() => optionsCycle[getIndexByValue(optionsCycle, activeItem)], [activeItem]);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter((item: any) => item?.date_start >= 1690772400000)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  useEffect(() => {
    if (!optionsCycle?.[0]) return;

    if (!activeItem && optionsCycle?.length > 0) {
      setActiveItem(optionsCycle[0].value);
    }
  }, [optionsCycle]);

  useEffect(() => {
    if (!id || !currentCycle || !activeItem) {
      return;
    }

    async function loadPlayerInfo() {
      if (!id) return;
      setLoadingMissionList(true);

      const userProfile = await getPublicProfile(id, activeCycleObj?._id);
      const playerInfo = await getPlayerInfo(id);
      setUserInfo(playerInfo);
      setCurrentUser(userProfile);

      const isGestor = playerInfo.tipo_ro === 'GERENCIAL' || playerInfo.funcao === 'DIRETOR';

      if (isGestor) {
        const dataGestor = await getMissaoGestorPublic(id, activeCycleObj.date_start, activeCycleObj.date_end);
        const dataEquipe = await getMissaoEquipePublic(id, activeCycleObj.date_start, activeCycleObj.date_end);
        setMissionList([...dataGestor, ...dataEquipe]);
      } else {
        const data = await getMissaoEquipePublic(id, activeCycleObj.date_start, activeCycleObj.date_end);
        setMissionList(data);
      }

      setLoadingMissionList(false);
    }

    async function loadReconhecimentos() {
      setLoadingList(true);
      const result = await getKPIPublicHistoryByTime(id, activeCycleObj.date_start, activeCycleObj.date_end, activeCycleObj._id);
      setList(result.filter((x: any) => !x.cancelled));
      setLoadingList(false);
    }

    loadPlayerInfo();
    loadReconhecimentos();
  }, [id, currentCycle, activeItem]);

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex justify-between items-center space-x-3 lg:space-x-2 mb-3 lg:mb-10">
        <div className="flex items-center">
          <div className="cursor-pointer" onClick={() => onClose()}>
            <button className="rounded-full bg-purple flex justify-center items-center p-1" aria-label="Botão: Voltar">
              <RiArrowLeftSLine size={28} className="text-white" />
            </button>
          </div>
          <h1 className="text-lg lg:text-3xl py-1 px-6">Perfil de {currentUser?.name}</h1>
        </div>
      </div>

      {userInfo && (
        <div className="flex flex-row items-center space-x-3 mb-5">
          <div className="w-32 h-32 md:w-44 md:h-44 bg-purple flex items-center justify-center rounded-full overflow-hidden text-3xl md:text-6xl">
            {!!currentUser?.extra.avatar_type &&
              (currentUser.image ? (
                <img src={currentUser.image.medium.url} alt={currentUser.name} className="w-full h-full" />
              ) : (
                currentUser.name[0]
              ))}
            {!currentUser?.extra.avatar_type &&
              (!!currentUser?.extra.avatar ? (
                <Avatar className="w-full h-full" {...currentUser.extra.avatar} />
              ) : (
                currentUser?.name[0]
              ))}
          </div>
          <div className="space-y-3">
            <div className="text-lg md:text-2xl text-white text-center font-bold" tabIndex={0}>
              {currentUser?.name} <span className="font-thin">({currentUser?._id})</span>
            </div>
            {userInfo && (
              <div className="md:text-xl font-thin">
                {currentUser?.level && (
                  <div className="mb-4 flex" tabIndex={0}>
                    <span>
                      Nível: <b className="text-electric-blue">{getLevelTitle(currentUser?.level)}</b>{' '}
                    </span>
                    <div className="ml-2" tabIndex={0} aria-label={`Nível definido.`}>
                      <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                    </div>
                  </div>
                )}

                {currentUser?.grupo ? (
                  <div className="flex items-center space-x-2 cursor-pointer" tabIndex={0}>
                    <span>{currentUser?.grupo ? currentUser.grupo : userInfo?.grupo?.nome}</span>{' '}
                    <span>({currentUser?.grupo_total ? currentUser?.grupo_total : userInfo?.grupo?.total} funci) </span>{' '}
                    <div className="ml-2" tabIndex={0} aria-label={`O seu grupo de classificação está definido.`}>
                      <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                    </div>
                    <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                      {userInfo?.ro}
                    </span>
                  </div>
                ) : (
                  <div className="md:text-xl font-thin" tabIndex={0}>
                    <span>{userInfo?.grupo?.nome}</span> <span>({userInfo?.grupo?.total} funci)</span>{' '}
                    <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                      {userInfo?.ro}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="mb-5 flex flex-col-reverse lg:flex-row  items-center justify-between lg:space-x-5">
        <div className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
          <p tabIndex={0}>
            Rede FLAP 360° | <span className="text-yellow"> {activeCycleObj?.label}</span>
          </p>
        </div>

        <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
          <CustomSelect
            placeholder="Clique para selecionar o ciclo"
            options={optionsCycle}
            value={activeCycleObj}
            onChange={(e: any) => setActiveItem(e.value)}
          />
        </div>
      </div>

      <div className="w-full flex flex-col space-y-5 mt-10">
        <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 flex">
          <button
            className={`${activeTab === 0 ? 'bg-slate-blue' : 'bg-maastricht-blue'} ${'w-full'} h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
            onClick={() => setActiveTab(0)}
          >
            Reconhecimentos recebidos
          </button>
          {/* {!user?.extra.rede && (
            <button
              className={`${
                activeTab === 1 ? 'bg-slate-blue' : 'bg-maastricht-blue'
              } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
              onClick={() => setActiveTab(1)}
            >
              Participação em realizações
            </button>
          )} */}
        </div>

        {activeTab === 0 && (
          <Box>
            <div className="space-y-5 lg:p-3">
              <h3 className="text-2xl mb-3" tabIndex={0}>
                Reconhecimentos recebidos <b className="text-yellow">{list ? `(${list?.length})` : null}</b>
              </h3>

              {loadingList ? (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              ) : null}

              {!loadingList ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {list?.map((item: any) => <RewardReviewItem data={item} key={item._id} />)}
                </div>
              ) : null}
            </div>
          </Box>
        )}

        {activeTab === 1 ? (
          <div className="space-y-2">
            {missionList?.map((item: any) => <RedePoint key={item._id} data={{ nome_uor: userInfo.nome_uor, ...item }} />)}

            {!missionList ||
              (missionList?.length === 0 && (
                <p className="font-bold text-lg text-center w-full" tabIndex={0}>
                  Nenhuma realização
                </p>
              ))}
          </div>
        ) : null}
      </div>

      {currentUser?._id && currentUser?.grupo && <GroupDetailModalExtrato player={currentUser?._id} />}
    </div>
  );
}
